
import Vue from 'vue';
import { mapState } from 'vuex';
import { ROUTER } from '@/router/constants';
import ListItem from '@/components/base/ListItem.vue';
import { IMMEDIATE_RUNNIT_TOKENS_BASE } from '@run-diffusion/shared';

export default Vue.extend({
	name: 'UnlockRdTrial',
	props: {
		showCcOptionsOnSubscriptionsPageRoute: { type: Boolean, default: false }
	},
	data () {
		return {
			IMMEDIATE_RUNNIT_TOKENS_BASE,
		};
	},
	computed: {
		...mapState([
			'authUser',
			'user',
		]),
		isEmailPassChecked () {
			return !!(
				this.authUser.emailVerified &&
				!this._get(this.user, 'freemiumInfo.invalidEmail')
			);
		},
		isFingerprintPassChecked () {
			return !!(
				!this._get(this.user, 'freemiumInfo.noFingerprint') &&
				!this._get(this.user, 'freemiumInfo.dupFingerprint')
			);
		},
	},
	methods: {
		onSubscriptionsPageRoute () {
			this.routerPush(this.$route, this.$router, {
				name: ROUTER.RUNNITS_SUBSCRIPTIONS,
				query: {
					...(this.showCcOptionsOnSubscriptionsPageRoute && {
						showCcOptions: '1',
					}),
				},
			});
		},
	},
	components: {
		ListItem,
	},
});
